import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../../../Context/browserContext";
import DataLoader from "../../../../ui/template/Data/DataLoader";
import AppConfig from "../../../Controllers/AppConfig";
import FriendState from "./All/FriendState";
import MemberFollow from "./MemberFollow";

var ps=new FriendState();

class    CityMember extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.HfunCV=this.funCV.bind(this);
        this.props=props;
    }

    funCV(data,ts,recordKey,selectFun=null){
        let rows=[];
        let l=data.length;
        let state=null;
        let s1=null;
        for (let i=0;i<l;i++){
            this.rowsId++;
            state = ps.getValueItem(data[i].state);
            s1='http://mdyaran.ir/membership/'+data[i].id+'/picture';
            let el=   <div className="col-md-4" key={this.rowsId}>
                <a href="javascript:void(0)">
                    <div className="border network-item rounded mb-3">
                        <div className="p-3 d-flex align-items-center network-item-header">
                            <div className="dropdown-list-image mr-3">
                                <img  src="/images/avatar.jpg" data-src={s1} alt=""   className="lazyload blur-up img-fluid  rounded-circle mw150"/>
                            </div>
                            <div className="font-weight-bold">
                                <h6 className="font-weight-bold text-dark mb-0">
                                    {data[i].username}
                                </h6>
                                <div className="small text-black-50">
                                    {data[i].username}
                                </div>
                            </div>
                        </div>
                        <MemberFollow memberId={data[i].id} />
                    </div>
                </a>
            </div>  ;
            rows.push(el);
        }
        ts.cv=<> <div className="row">{rows} </div> </>;
    }





   

    render() {

        return (
            <div className="p-3 w-100">
                <DataLoader ref={this.table1} scope="route" name="cityMember" lengthTable={9}
                            baseUrl={AppConfig.base_url} orderColumn={1} orderDir={2}
                            srcName="cityMember" getBoxItem={ this.HgetBoxItem} selectable={false}
                            funCustomVeiw={ this.HfunCV} isCustomVeiw={true} className="" isHeader={false}
                            queryFields="id,state,username,imageType"/>
            </div>

        );
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

CityMember.contextType = MCbrowser;

export default CityMember;
